module.exports = __webpack_public_path__ + "assets/media/6.4b3fc6ae.wav";